import { useSearchContext } from '../../contexts/SearchContext';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import types from './search-types.json';

export default function SearchTypeSetter() {
    const routes: any = { ...types };

    const { setSearchType } = useSearchContext();
    const { pathname } = useLocation();

    useEffect(() => {
        let typeUpdated = false;
        for (const regex of Object.keys(types)) {
            const expression = new RegExp(regex);
            if (expression.test(pathname) && routes.hasOwnProperty(regex)) {
                setSearchType(routes[regex]);
                typeUpdated = true;
            }
        }

        if (!typeUpdated) {
            setSearchType(undefined);
        }
    }, [pathname]);

    return null;
}
